.search-facets-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  margin-bottom: 48px;

  ui-container {
    max-width: 100vw;
    width: 480px;
  }

  ui-cms-offcanvas-panel .slide {
    background-color: $ui-grey-minus-3;
  }

  ui-download-search-facet {
    margin-top: 40px;
    border-top: solid $ui-grey 1px;
    padding-top: 20px;
  }

  .search-facets {
    &__link {
      justify-self: flex-end;
      margin-top: 10px;
    }

    &__results-number {
      margin-right: auto;
    }

    &__button {
      margin-right: 40px;
    }

    &-panel__link {
      position: absolute;
      top: 0;
      left: 0;
      margin: 20px 0 20px 24px;
    }

    &-panel__button,
    &-panel__button--reset {
      width: 100%;
    }

    &-panel__button {
      margin-top: 50px;
    }

    &-panel__button--reset {
      margin-top: 16px;
    }

    &__button-sort {
      margin-top: 12px;
    }
  }

  &.mobile {
    flex-direction: column;
    align-items: stretch;

    .search-facets {
      &__button {
        width: 100%;
        margin-right: 0;
      }

      &__results-number {
        margin-top: 12px;
      }

      &__results-reset {
        margin-top: 0;
        align-self: start;
      }

      &__link {
        &,
        &-disabled {
          margin-top: 16px;
          margin-right: auto;
        }
      }
    }
  }
}
